// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-travel-mode {
  display: block;
  margin: var(--wm-feature-details-margin);
}
wm-travel-mode ion-label {
  font-size: var(--wm-feature-details-title-font-size);
  font-weight: var(--wm-feature-details-title-font-weight);
  color: var(--wm-feature-details-title-color);
  font-family: var(--wm-feature-details-title-font-family);
}
wm-travel-mode ion-segment {
  padding: 4px;
  border-radius: 25px;
  margin: 10px 0px;
}
wm-travel-mode ion-segment ion-segment-button {
  --border-radius: 25px;
  height: 36px;
}
wm-travel-mode ion-segment ion-segment-button.segment-button-checked ion-icon {
  color: var(--wm-color-primary);
}
wm-travel-mode ion-grid ion-row ion-col {
  display: flex;
  flex-direction: column;
}
wm-travel-mode ion-grid ion-row ion-col > div:first-child {
  min-height: 40px;
  font-size: 22px;
  font-weight: 700;
  color: var(--ion-text-color);
  display: flex;
  gap: 6px;
  align-items: baseline;
}
wm-travel-mode ion-grid ion-row ion-col > div:first-child .unit {
  font-size: 14px;
}
wm-travel-mode ion-grid ion-row ion-col > div:first-child.to-delete {
  color: var(--wm-color-primary);
  font-size: 44px;
  line-height: 33px;
}
wm-travel-mode ion-grid ion-row ion-col > div:last-child {
  font-size: 14px;
  font-weight: 400;
  color: var(--ion-text-color);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/travel-mode/travel-mode.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,wCAAA;AACF;AACE;EACE,oDAAA;EACA,wDAAA;EACA,4CAAA;EACA,wDAAA;AACJ;AAEE;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AACI;EACE,qBAAA;EACA,YAAA;AACN;AACQ;EACE,8BAAA;AACV;AAOM;EACE,aAAA;EACA,sBAAA;AALR;AAMQ;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,QAAA;EACA,qBAAA;AAJV;AAKU;EACE,eAAA;AAHZ;AAKU;EACE,8BAAA;EACA,eAAA;EACA,iBAAA;AAHZ;AAMQ;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;AAJV","sourcesContent":["wm-travel-mode {\n  display: block;\n  margin: var(--wm-feature-details-margin);\n\n  ion-label{\n    font-size: var(--wm-feature-details-title-font-size);\n    font-weight: var(--wm-feature-details-title-font-weight);\n    color: var(--wm-feature-details-title-color);\n    font-family: var(--wm-feature-details-title-font-family);\n  }\n\n  ion-segment{\n    padding: 4px;\n    border-radius: 25px;\n    margin: 10px 0px;\n    ion-segment-button{\n      --border-radius: 25px;\n      height: 36px;\n      &.segment-button-checked{\n        ion-icon{\n          color: var(--wm-color-primary);\n        }\n      }\n    }\n  }\n\n  ion-grid{\n    ion-row{\n      ion-col{\n        display: flex;\n        flex-direction: column;\n        > div:first-child{\n          min-height: 40px;\n          font-size: 22px;\n          font-weight: 700;\n          color: var(--ion-text-color);\n          display: flex;\n          gap: 6px;\n          align-items: baseline;\n          .unit{\n            font-size: 14px;\n          }\n          &.to-delete{\n            color: var(--wm-color-primary);\n            font-size: 44px;\n            line-height: 33px;\n          }\n        }\n        > div:last-child{\n          font-size: 14px;\n          font-weight: 400;\n          color: var(--ion-text-color);\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
